import { defaultSelect } from 'src/constants'

const useMediaTypeSelectionOption = () => {
  const values = [
    { value: 'application/pdf', label: 'application/pdf' },
    { value: 'image/jpeg', label: 'image/jpeg' },
    { value: 'image/png', label: 'image/png' },
    { value: 'image/svg+xml', label: 'image/svg+xml' },
    { value: 'image/webp', label: 'image/webp' },
    { value: 'url', label: 'url' },
    { value: 'video/mp4', label: 'video/mp4' },
  ]

  values.unshift(defaultSelect)

  return { selectName: 'media-type-filter-title.v', queryParamName: 'media_type', items: values }
}

export { useMediaTypeSelectionOption }
